// extracted by mini-css-extract-plugin
export default {"links_footer":"Footer_links_footer__C210S","direitos":"Footer_direitos__KM3nL","redes_sociais":"Footer_redes_sociais__huXl2"};